(ns common.schema.system
  (:require
   [common.opensearch.fields :as os-fields]))

(def hidden-system-field-attributes
  #{:entity/type
    :common/archived?
    :common/change-meta
    :common/containing-entity
    :common/disabled?
    :common/disabled-on
    :common/gift-sample?
    :common/migration-note
    :common/ord
    :common/system-kws
    :common/tenant
    :common/zap-sample?})

(defn hidden-system-field-attribute?
  [field-attribute]
  (and (keyword? field-attribute)
       (contains? hidden-system-field-attributes field-attribute)))

(defn hidden-system-field-path?
  [field-path]
  (hidden-system-field-attribute? (os-fields/field-path->last-kw field-path)))

(defn hidden-system-field?
  ([field-path]
   (hidden-system-field-path? field-path))
  ([field-path field-schema]
   (or (hidden-system-field-path? field-path)
       (hidden-system-field-attribute? (:field/attribute field-schema))
       (hidden-system-field-attribute? (:attribute field-schema)))))
